import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Empty, Form, Input, PageHeader, Row, Select, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import moment from 'moment';

import accountService from "../../api/account.service";
import memberService from "../../api/member.service";
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'
import VoucherListView from "../../components/voucher/VoucherListView";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from '../../utility/Constants'
import commonUtility from "../../utility/Utils";
import OtherItemsListView from "../../components/otheritem/OtherItemsListView";
import TimeScheduleReport from "./TimeScheduleReport";
import commonService from "../../api/common.service";
const { Option } = Select;


const defaultFormValues = {
    receipt_start_date: commonUtility.todayDate("/"),
    receipt_end_date: commonUtility.todayDate("/"),
    member_id: "",
};



const TimeScheduleReportView = () => {
    const [form] = Form.useForm();



    const [isDataUpdated, setIsDataUpdated] = useState(false);

    const [programmeList, setProgrammeList] = useState([]);
    const [programmeGroupList, setProgrammeGroupList] = useState([]);
    const [timeSlotList, setTimeSlotList] = useState([]);
    const [memberList, setMemberList] = useState([]);

    const [programmeID, setProgrammeID] = useState(0);
    const [reportList, setReportList] = useState([]);
    const [dayList, setDayList] = useState([]);
    const [loading, setLoading] = useState(false);

    console.log("reportListRH", reportList)

    // const onFromDateChange = (date, dateString) => {
    //     // console.log(date, dateString);
    //     setSelectedFromDate(dateString)
    //     form.setFieldsValue({
    //         receipt_start_date: dateString
    //     });
    // };

    // const onEndDateChange = (date, dateString) => {
    //     // console.log(date, dateString);
    //     setSelectedEndDate(dateString)
    //     form.setFieldsValue({
    //         receipt_end_date: dateString
    //     });

    // };


    const onSelectMember = (value) => {
        const data = { formdata: { member_id: value } };

        form.setFieldsValue({
            member_id: value
        });
    };



    // const onOtherItemsSearched = async (values) => {

    //     setReportList([])
    //     const formdValues = {
    //         programme_id: values.programme_id == undefined ? '' : values.programme_id,
    //         member_id: values.member_id == undefined ? '' : values.member_id,
    //         group_id: values.group_id == undefined ? '' : values.group_id,
    //         // time_slot_id: values.time_slot_id == undefined ? '' : values.time_slot_id,
    //         day_id: values.day_id == undefined ? '' : values.day_id,
    //     }

    //     const data = { formdata: formdValues };
    //     console.log("formData", data);
    //     ProgrammeService.memberTimeSlotReport(data).then((res) => {
    //         console.log("resData", res);
    //         if (res.data.response_status == SUCCESS_STATUS) {
    //             let formatted_data = ConvertedData(res.data);
    //             setReportList(formatted_data);
    //         }
    //         else {
    //             setReportList([])
    //         }
    //         setIsDataUpdated(!isDataUpdated)
    //     });
    // };

    const onOtherItemsSearched = async (values) => {
        setLoading(true);
        setReportList([]);

        const formdValues = {
            programme_id: values.programme_id || '', // Default to empty string if undefined
            member_id: values.member_id || '',
            group_id: values.group_id || '',
            day_id: values.day_id || '',
        };

        const data = { formdata: formdValues };
        console.log("formData", data);

        try {
            const res = await ProgrammeService.memberTimeSlotReport(data);
            console.log("resData", res);
            if (res.statusText === "OK") {
                setReportList(res.data);
            } else {
                setReportList([]);
            }
        } catch (error) {
            setReportList([]);
        } finally{
            setLoading(false);
        }
        setIsDataUpdated(!isDataUpdated);
    };



    const ConvertedData = (data) => {
        const formattedData = data.data.map((item) => {
            const groupedData = item.DayData.reduce((acc, curr) => {
                if (!acc[curr.day_name]) {
                    acc[curr.day_name] = [];
                }
                acc[curr.day_name].push({
                    member_fname: curr.member_fname,
                    member_lname: curr.member_lname,
                    father_name: curr.father_name,
                    primary_mobile: curr.primary_mobile,
                    gender: curr.gender,
                    enrollment_date: curr.enrollment_date,
                });
                return acc;
            }, {});

            return {
                // timeSlot: item.timeSlot,
                DayData: groupedData,
            };
        });

        return formattedData;
    }

    const onProgrammeChange = (id, object) => {
        getTimeSchedule();
        getMemberList(object?.short_code)
    }



    useEffect(() => {
        ProgrammeService.programmeListForScheduleReport().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeList(res.data.response_data);
            }
        });
    }, []);


    /*
    useEffect(() => {
        memberService.allMember().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }, []);
    */


    useEffect(() => {
        ProgrammeService.programmeGroupList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeGroupList(res.data.response_data);
            }
        });
    }, []);

    useEffect(() => {
        commonService.dayList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setDayList(res.data.response_data);
            }
        });
    }, []);



    const getTimeSchedule = () => {
        const data = {
            formdata: {
                programme_id: form.getFieldValue('programme_id')
            }
        };

        ProgrammeService.timeSlotByProgramme(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setTimeSlotList(res.data.response_data);
            }
        });
    }


    const getMemberList = (short_code) => {

        form.setFieldsValue({
            member_search: '',
            member_id: ''
        });

        const data = {
            formdata: {
                programme_id: short_code
            }
        };

        ProgrammeService.memberListPromoted(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }


    // useEffect(() => {
    //     const formdValues = {
    //         member_id: form.getFieldValue('member_id') == undefined ? '' : form.getFieldValue('member_id'),
    //         receipt_start_date: commonUtility.todayDate("/"),
    //         receipt_end_date: commonUtility.todayDate("/"),
    //     }
    //     onOtherItemsSearched(formdValues)
    // }, [])

    return (
        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Time Slot Report"
                        subTitle=""

                    ></PageHeader>

                    <div className="">



                        <Row className="" style={{ background: "rgb(249, 249, 249)" }}>
                            <Col className="" xs={24} xl={24} style={{ margin: "0.5rem" }}>
                                <Form
                                    form={form}
                                    layout="vertical"
                                    onFinish={onOtherItemsSearched}
                                    autoComplete="off"
                                    initialValues={defaultFormValues}
                                >

                                    <Row gutter={10} >

                                        <Col xs={24} xl={6}>
                                            <Form.Item
                                                name="programme_id"
                                                label="Programme"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Programme is required",
                                                    },
                                                ]}
                                            >
                                                <Select className="text-left"
                                                    onSelect={(value, event) =>
                                                        onProgrammeChange(value, event)
                                                    }
                                                >
                                                    {/* <Option value="">Select</Option> */}
                                                    {programmeList.length > 0
                                                        ? programmeList.map((programme_list) => (
                                                            <Option
                                                                key={programme_list.programme_id}
                                                                value={programme_list.programme_id}
                                                                short_code={programme_list.short_code}
                                                            >
                                                                {programme_list.programme_name}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>




                                        <Col xs={24} xl={5}>
                                            <Form.Item
                                                name="group_id"
                                                label="Shift"
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Group is required",
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    className="text-left"
                                                    // defaultValue="Select"
                                                //onSelect={(value, event) => onSelectProgrammeGroup(value, event)}

                                                >
                                                    <Option value="">Select</Option>
                                                    {programmeGroupList.length > 0
                                                        ? programmeGroupList.map((programme_group_list) => (
                                                            <Option
                                                                key={programme_group_list.programme_group_id}
                                                                value={programme_group_list.programme_group_id}
                                                            >
                                                                {programme_group_list.programme_group}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={5}>
                                            <Form.Item
                                                name="day_id"
                                                label="Day"

                                            >
                                                <Select
                                                    className="text-left"
                                                    defaultValue="Select"
                                                >
                                                    <Option value="">Select</Option>
                                                    {dayList.length > 0
                                                        ? dayList.map((day_list) => (
                                                            <Option
                                                                key={day_list.day_id}
                                                                value={day_list.day_id}
                                                            >
                                                                {day_list.day_name}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        {/* <Col xs={6} xl={8}>
                                            <Form.Item
                                                name="member_id"
                                                label="Member (Opional)"

                                            >
                                                <Select
                                                    showSearch
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children
                                                            .toLowerCase()
                                                            .localeCompare(optionB.children.toLowerCase())
                                                    }
                                                    onSelect={(value, event) =>
                                                        onSelectMember(value, event)
                                                    }
                                                    allowClear={true}
                                                >
                                                    {memberList.length > 0
                                                        ? memberList.map((member_list) => (
                                                            <Option
                                                                key={member_list.member_id}
                                                                value={member_list.member_id}
                                                            >
                                                                {`${member_list.member_fname} ${member_list.member_lname
                                                                    } | ${member_list.primary_mobile}  ${member_list.father_name != null
                                                                        ? member_list.father_name
                                                                        : ""
                                                                    }`}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>

                                            </Form.Item>
                                        </Col> */}

                                        {/* <Col xs={24} xl={5}>
                                            <Form.Item
                                                name="time_slot_id"
                                                label="Time Slot"
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Time Slot is required",
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    className="text-left"
                                                //onSelect={(value, event) => onSelectProgrammeGroup(value, event)}
                                                >
                                                    <Option value="">Select</Option>
                                                    {timeSlotList.length > 0
                                                        ? timeSlotList.map((time_slot_list) => (
                                                            <Option
                                                                key={time_slot_list.time_slot_id}
                                                                value={time_slot_list.time_slot_id}
                                                            >
                                                                {time_slot_list.time_slot}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col> */}
                                        <Col xs={24} xl={1}>
                                            <Form.Item label=" ">
                                                <Button
                                                    htmlType="submit"
                                                    shape="round"
                                                    loading={loading} 
                                                    className="custom-button-green"
                                                >
                                                    <SearchOutlined />
                                                </Button>
                                            </Form.Item>
                                        </Col>





                                    </Row>
                                </Form>



                            </Col>
                        </Row>


                        {/* <VoucherListView voucherListValue={voucherList} voucherMasterDataValue={voucherMasterData} voucherDetailDataValue={voucherDetailData} isDataUpdatedValue={isDataUpdated}/> */}

                        {/* <OtherItemsListView /> */}



                        <div className='tableView'>
                            <div className="form-content">
                                {/* <OtherItemsListView otherItemListValue={otherItemsList} otherItemsMasterListValue={otherItemsMasterList} otherItemsDetailListValue={otherItemsDetailList} isDataUpdatedValue={isDataUpdated} /> */}
                                {
                                    reportList.length > 0 ? <>
                                        <TimeScheduleReport reportList={reportList} isDataUpdatedValue={isDataUpdated} />
                                    </> : <><Empty /></>
                                }

                            </div>
                        </div>




                    </div>

                </div>
            </div>

        </div>


    )
}

export default TimeScheduleReportView